import { Injectable } from '@angular/core';
import { HolidayRegionCode } from '@wilson/interfaces';
import { WilsonState } from '@wilson/non-domain-specific/decorators/wilson-state';
import { MODAL_VIEW } from '@wilson/shift-timeline/state';
import { Observable } from 'rxjs';

const hoursPerZoomLevel = new Map([
  [
    MODAL_VIEW.SHIFT,
    ['00:00', '04:00', '08:00', '12:00', '16:00', '20:00', '24:00'],
  ],
  [
    MODAL_VIEW.ACTIVITY,
    [
      '00:00',
      '01:00',
      '02:00',
      '03:00',
      '04:00',
      '05:00',
      '06:00',
      '07:00',
      '08:00',
      '09:00',
      '10:00',
      '11:00',
      '12:00',
      '13:00',
      '14:00',
      '15:00',
      '16:00',
      '17:00',
      '18:00',
      '19:00',
      '20:00',
      '21:00',
      '22:00',
      '23:00',
      '24:00',
    ],
  ],
]);
const defaultRowHeight = 70;

@Injectable()
export class FindStaffGanttChartService {
  @WilsonState<string[]>(hoursPerZoomLevel.get(MODAL_VIEW.SHIFT) as string[])
  hoursRange!: string[];
  hoursRange$!: Observable<string[]>;

  @WilsonState<number>(defaultRowHeight)
  ganttChartDefaultRowHeight!: number;
  ganttChartDefaultRowHeight$!: Observable<number>;

  @WilsonState<HolidayRegionCode>([])
  publicHolidaysRegion!: HolidayRegionCode;
  publicHolidaysRegion$!: Observable<HolidayRegionCode>;

  @WilsonState<MODAL_VIEW>(MODAL_VIEW.SHIFT)
  modalView!: MODAL_VIEW;
  modalView$!: Observable<MODAL_VIEW>;

  setHolidaysRegion(regions: HolidayRegionCode | null | undefined): void {
    this.publicHolidaysRegion = regions || [];
  }

  setHoursRange(value: MODAL_VIEW): void {
    this.hoursRange = hoursPerZoomLevel.get(value) as string[];
  }

  setViewAndHoursRange(value: MODAL_VIEW): void {
    this.modalView = value;
    this.hoursRange = hoursPerZoomLevel.get(value) as string[];
  }

  setDefaultRowHeight(value: number): void {
    this.ganttChartDefaultRowHeight = value;
  }
}
